module.exports = __webpack_public_path__ + "img/moneyIcon.89124138.png";